// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 菜单和路由设置

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// axios

import App from './App'
import {
	post
} from '@/utils/loginGlobal';
Vue.prototype.$post = post;
import {
	postcn
} from '@/utils/loginGlobal';
Vue.prototype.$postcn = postcn;
// jsonP
import VueJsonp from 'vue-jsonp';
// 引入公共css
import "@/assets/css/global.css";
import "@/assets/css/reset.css";
// 引入iconfont
import './assets/iconfont/iconfont.css'
import BaiduMap from 'vue-baidu-map'
import $ from 'jquery'
import router from './router'
import promise from 'es6-promise'
promise.polyfill()
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
	Options: {
		'inline': true,
		'button': true,
		'navbar': true,
		'title': true,
		'toolbar': true,
		'tooltip': true,
		'movable': true,
		'zoomable': true,
		'rotatable': true,
		'scalable': true,
		'transition': true,
		'fullscreen': true,
		'keyboard': true,
		'url': 'data-source'
	}
})
// 核心插件
Vue.use(ElementUI);
Vue.use(VueJsonp);
Vue.directive('title', {
	inserted: function(el, binding) {
		document.title = el.dataset.title
	}
})
Vue.use(BaiduMap, {
	ak: 'UUcXpjAR93qiAdKzKFuXf9x15leRLf6K'
});

new Vue({
	router,
	post,
	postcn,
	VueJsonp,
	render: h => h(App),
	mounted() {
		document.dispatchEvent(new Event('render-event'))
	}
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js